
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 512 512"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M500.59 157.733L424.118 9.035C421.33 3.614 415.765 0 409.067 0H102.931c-.042 0-.084.003-.127.004-.039-.001-.079-.004-.117-.004h-.007a16.648 16.648 0 00-14.799 9.035L11.408 157.733c-2.703 5.258-2.351 11.53.594 16.287.169.336 230.213 330.71 230.443 331.031 6.688 9.336 20.637 9.252 27.192-.17 1.278-1.835 229.948-330.18 230.396-330.925a16.685 16.685 0 00.557-16.223zM381.782 33.299l-49.201 95.672c-28.87-56.027-17.64-34.209-49.248-95.672h98.449zM256.011 53.071c28.797 55.887 17.579 34.093 49.225 95.627h-98.501l49.276-95.627zm-27.295-19.772l-49.299 95.672-49.201-95.672h98.5zM102.8 53.217l49.2 95.481H53.539L102.8 53.217zm-44.706 128.78h108.102l54.01 232.854L58.094 181.997zM255.973 421.68l-55.594-239.682h111.188L255.973 421.68zm35.761-6.805l54.016-232.878H453.9L291.734 414.875zM360 148.698l49.298-95.672 49.202 95.672H360z"}})])
          )
        }
      }
    